import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[mlSelectOption]',
})
export class SelectOptionDirective {
  readonly template = inject<TemplateRef<{ $implicit: unknown }>>(TemplateRef);
}

@Directive({
  selector: 'ng-template[mlSelectValue]',
})
export class SelectValueDirective {
  readonly template = inject<TemplateRef<{ $implicit: unknown }>>(TemplateRef);
}
